import React from "react";
import TextField from "@material-ui/core/TextField";
import Translate from "../../../common/functions/translate";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ChooseClientDialog from '../chooseClientDialog';
import { ClientSearchModel } from "../../../models/client/clientSearchModel";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { Button } from "@material-ui/core";
import EditClientDataDialog from '../editClientDataDialog';
import { ClientModel } from "../../../models/client/clientModel";
import EditClientAddressDialog from '../editClientAddressDialog';
//import Link from '@material-ui/core/Link';

const ClientDataComponent = (props: any) => {
    const [chooseClientIsOpen, openChooseClient] = React.useState(false);
    const [editClientDataIsOpen, openEditClientData] = React.useState(false);
    const [editClientAddressIsOpen, openEditClientAddress] = React.useState(false);

    let toggleChooseClientDialog = (isVis) => {
        openChooseClient(isVis);
    }

    let toggleEditClientDataDialog = (isVis) => {
        openEditClientData(isVis);
    }

    let toggleEditClientAddressDialog = (isVis) => {
        openEditClientAddress(isVis);
    }

    let chooseClientClick = (e) => {
        toggleChooseClientDialog(true)
    }

    let onClientSelected = (selectedClient: ClientSearchModel) => {
        toggleChooseClientDialog(false);
        props.handleExistingClientSelected(selectedClient);
    }

    let handleNewClientClick = () => {
        props.handleNewClient();
    }

    let editClientDataClick = () => {
        toggleEditClientDataDialog(true);
    }

    let editClientAddressClick = () => {
        toggleEditClientAddressDialog(true)
    }

    let editClientData = (client: ClientModel) => {
        toggleEditClientDataDialog(false);
        toggleEditClientAddressDialog(false);
        props.handleEditClient(client);
    }

    return <>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            {props.selectedClientId === 0
                ? <div>
                    <div style={{ marginBottom: 10 }}>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <TextField
                                name="name"
                                label={Translate("Client name")}
                                type="text"
                                error={props.validations.includes("name")}
                                onChange={(e) => props.onChangeClient('name', e.target['value'])}
                                value={props.clientData?.name || ""}
                                style={{ width: 300, marginRight: 10 }}
                            />
                            {/* eslint-disable-next-line */}
                            <a href="#" style={{ marginTop: 17 }} onClick={chooseClientClick}>{Translate('Choose client')}</a>
                        </div>
                    </div>
                    <div style={{ marginBottom: 10 }}>
                        <TextField
                            name="email"
                            type="email"
                            label={Translate("Email")}
                            onChange={(e) => props.onChangeClient('email', e.target['value'])}
                            value={props.clientData?.email || ""}
                            style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                        />
                        <TextField
                            name="phone"
                            type="text"
                            label={Translate("Phone")}
                            onChange={(e) => props.onChangeClient('phone', e.target['value'])}
                            value={props.clientData?.phone || ""}
                            style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                        />
                    </div>
                </div>
                : <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 30, marginTop: 20 }}>
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                            {Translate('Client name')}:
                    <strong style={{ marginLeft: 5 }}>{props.clientData?.name || ""}</strong>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                            {Translate('Email')}:
                    <strong style={{ marginLeft: 5 }}>{props.clientData?.email || ""}</strong>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                            {Translate('Phone')}:
                    <strong style={{ marginLeft: 5 }}>{props.clientData?.phone || ""}</strong>
                        </div>
                        {!props.readOnly
                            ? <div style={{ display: 'flex', flexDirection: 'row' }}>
                                {/* eslint-disable-next-line */}
                                <a href="#" onClick={handleNewClientClick} style={{ marginRight: 5 }}>{Translate('New client')}</a>
                                <span>|</span>
                                {/* eslint-disable-next-line */}
                                <a href="#" onClick={chooseClientClick} style={{ marginLeft: 5 }}>{Translate('Choose client')}</a>
                            </div>
                            : null}

                    </div>
                    <div style={{ marginLeft: 20 }}>
                        <Button className="action-button" variant="contained" color='primary' onClick={editClientDataClick} disabled={props.readOnly}>
                            <FontAwesomeIcon icon={faPen} />
                        </Button>
                    </div>
                </div>}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {props.selectedClientId !== 0
                    ? <div style={{ marginBottom: 10, marginLeft: 60 }}>
                        <FormControl style={{ width: 615 }}>
                            <InputLabel htmlFor="address-label">{Translate('Address')}</InputLabel>
                            <Select
                                name="address"
                                value={props.selectedAddress ? props.selectedAddress : 0}
                                onChange={(e) => props.handleDwopdownAddressChange(e.target.value)}
                                style={{ marginRight: 10 }}
                                disabled={props.readOnly}
                                inputProps={{
                                    id: 'address-label'
                                }}
                            >
                                {
                                    props.clientAddresses.map(m => <MenuItem key={m.value + 'address'} value={m.value}> {m.label}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </div>
                    : null}
                {props.selectedAddress === 0
                    ? <div style={{ marginBottom: 20, display: 'flex', flexDirection: 'column', marginLeft: props.selectedClientId ? 60 : 0 }}>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <TextField
                                name="disctrict"
                                label={Translate("Disctrict")}
                                type="text"
                                onChange={(e) => props.onChangeClient('disctrict', e.target['value'])}
                                value={props.clientData?.disctrict || ""}
                                style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                            />
                            <TextField
                                name="municipality"
                                type="text"
                                label={Translate("Municipality")}
                                onChange={(e) => props.onChangeClient('municipality', e.target['value'])}
                                value={props.clientData?.municipality || ""}
                                style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                            />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <TextField
                                name="town"
                                type="text"
                                label={Translate("Town")}
                                onChange={(e) => props.onChangeClient('town', e.target['value'])}
                                error={props.validations.includes("town")}
                                value={props.clientData?.town || ""}
                                style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                            />
                            <TextField
                                name="address"
                                type="text"
                                error={props.validations.includes("address")}
                                label={Translate("Address")}
                                onChange={(e) => props.onChangeClient('address', e.target['value'])}
                                value={props.clientData?.address || ""}
                                style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                            />
                        </div>
                    </div>
                    : <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 60 }}>
                        <div>
                            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                                {Translate('Disctrict')}:
                    <strong style={{ marginLeft: 5 }}>{props.clientData?.disctrict || ""}</strong>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                                {Translate('Municipality')}:
                    <strong style={{ marginLeft: 5 }}>{props.clientData?.municipality || ""}</strong>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                                {Translate('Town')}:
                    <strong style={{ marginLeft: 5 }}>{props.clientData?.town || ""}</strong>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                                {Translate('Address')}:
                    <strong style={{ marginLeft: 5 }}>{props.clientData?.address || ""}</strong>
                            </div>
                        </div>
                        <div style={{ marginLeft: 20 }}>
                            <Button className="action-button" variant="contained" color='primary' onClick={editClientAddressClick} disabled={props.readOnly}>
                                <FontAwesomeIcon icon={faPen} />
                            </Button>
                        </div>
                    </div>}
            </div>
        </div>
        {/* <div>
            {props.clientData?.latitude || props.clientData?.longitude
                ? <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5 }}>
                    <Link href={`https://maps.google.com/?q=${props.clientData.latitude},${props.clientData.longitude}`}
                        target="_blank"
                        style={{ marginLeft: "10px" }}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <FontAwesomeIcon icon={faMapMarked} style={{ fontSize: "30px", marginRight: "5px" }} />
                            <span style={{ marginTop: 10 }}>{props.clientData.latitude}, {props.clientData.longitude}</span>
                        </div>
                    </Link>
                    <div style={{ marginLeft: 5, marginTop: 7, cursor: 'pointer' }} onClick={props.removeLocation}>
                        <FontAwesomeIcon icon={faTrashAlt} color={'#f50057'} size="lg" />
                    </div>

                </div>
                : <div style={{ marginTop: 5 }}><Button
                    onClick={props.getLocation}
                    color="primary"
                    variant="contained"
                    size="small">
                    {Translate('Get location')}
                </Button></div>}
        </div> */}

        <div style={{ marginTop: 20 }}>
            {/* <div style={{ maxWidth: 320 }}>
                <FormControlLabel
                    labelPlacement={"start"}
                    style={{ display: 'flex', justifyContent: 'space-between', margin: 0 }}
                    control={
                        <Switch color="primary" checked={props.workAndMaterials || false} onChange={(e) => props.handleWorkSwitchChange(e.target.checked)} disabled={props.readOnly} />
                    }
                    label={Translate("WorkAndMaterials")}
                />
            </div> */}
            <div style={{ maxWidth: 400 }}>
                <FormControlLabel
                    labelPlacement={"start"}
                    style={{ display: 'flex', justifyContent: 'space-between', margin: 0 }}
                    control={
                        <Switch color="primary" checked={props.equipmentOnly || false}
                            onChange={(e) => props.handleEquipmentOnlySwitchChange(e.target.checked)} disabled={props.readOnly} />
                    }
                    label={Translate('Equipment only')}
                />
            </div>
            <div style={{ maxWidth: 400 }}>
                <FormControlLabel
                    labelPlacement={"start"}
                    style={{ display: 'flex', justifyContent: 'space-between', margin: 0 }}
                    control={
                        <Switch color="primary" checked={props.heatInstall || false}
                            onChange={(e) => props.handleHeatSwitchChange(e.target.checked)} disabled={props.readOnly} />
                    }
                    label={Translate("HeatingInstallation")}
                />
            </div>
        </div>

        {chooseClientIsOpen
            ? <ChooseClientDialog
                isOpen={chooseClientIsOpen}
                toggle={toggleChooseClientDialog}
                clientSelected={onClientSelected} />
            : null}

        {editClientDataIsOpen
            ? <EditClientDataDialog
                isOpen={editClientDataIsOpen}
                toggle={toggleEditClientDataDialog}
                onChangeClient={props.onChangeClient}
                selectedClient={props.clientData}
                onEditClientData={editClientData} />
            : null}

        {editClientAddressIsOpen
            ? <EditClientAddressDialog
                isOpen={editClientAddressIsOpen}
                toggle={toggleEditClientAddressDialog}
                selectedClient={props.clientData}
                onEditClientAddress={editClientData}
            />
            : null}
    </>

}

export default ClientDataComponent;
